<template>
  <section id="business" class="services-section">
    <div class="container">
      <div class="section-title" data-aos="fade-up">
        <h2>{{ $t("business.title") }}</h2>
        <div class="section-title-subtitle">{{ $t("business.subtitle") }}</div>
      </div>

      <div class="services-grid">
        <div v-for="(item, index) in $t('business.items')" :key="index" class="service-card" :data-aos="'fade-up'" :data-aos-delay="index * 100">
          <i :class="item.icon" class="service-icon"></i>
          <h3 class="service-title">{{ item.title }}</h3>
          <p class="service-description">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "BusinessSection",
};
</script>

<style scoped>
.services-section {
  padding: 100px 40px;
  background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
}

.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 42px;
  color: var(--section-title-color);
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-title h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  border-radius: 2px;
}

.section-title-subtitle {
  color: #666;
  font-size: 18px;
  margin-top: 25px;
}

.services-grid {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 35px;
}

.service-card {
  background: white;
  border-radius: 20px;
  padding: 45px 35px;
  transition: all 0.4s ease;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.service-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(78, 106, 122, 0.05) 0%, rgba(49, 148, 178, 0.05) 100%);
  transition: left 0.5s ease;
}

.service-card:hover::before {
  left: 0;
}

.service-card:hover {
  transform: translateY(-12px);
  box-shadow: 0 20px 40px rgba(49, 148, 178, 0.2);
}

.service-icon {
  width: 90px;
  height: 90px;
  background: linear-gradient(135deg, var(--icon-gradient-start), var(--icon-gradient-end));
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  font-size: 42px;
  color: white;
}

.service-card:hover .service-icon {
  animation: pulse 1s ease infinite;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}

.service-title {
  font-size: 22px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.service-description {
  color: #666;
  font-size: 15px;
  line-height: 1.6;
}

@media (max-width: 1024px) {
  .services-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .services-section {
    padding: 60px 20px;
  }

  .section-title h2 {
    font-size: 32px;
  }

  .services-grid {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .service-card {
    padding: 35px 25px;
  }

  .service-icon {
    width: 75px;
    height: 75px;
    font-size: 36px;
  }

  .service-title {
    font-size: 20px;
  }

  .service-description {
    font-size: 14px;
  }
}
</style>
